/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
//custom style
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import styles from "assets/jss/material-dashboard-react/components/cardStyle.js";
const useStyles = makeStyles(styles);

function ComplexStatisticsCard({ color, title, count, percentage, icon }) {
  const classes = useStyles();
  return (
    <Card className={ classes.cardDashboard } sx={{  opacity: percentage.opacity}}>
      <MDBox display="flex" justifyContent="space-between" py={1} px={1.6} className={classes.cardMdBox }>
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
        >
          <span className="material-icons">
          {icon}
          </span>
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.25}> 
          <MDTypography variant="button" className={ classes.cardTypo }>
            {title}
          </MDTypography>
          <MDTypography variant="h4">{count}</MDTypography>
        </MDBox>
      </MDBox>
      <Divider />
      <MDBox className={classes.cardMdInnerBox}>
        <MDTypography component="p" variant="button" color="text" display="flex" className={classes.cardParagraph}>
          <MDTypography
            component="span"
            variant="button"
            fontWeight="bold"
            color={percentage.color}
            className={classes.cardParagraph}
          >
          {percentage.link ? 
          <Link title="Successfully finished and Running Pods" className={classes.cardLink} to={percentage.link}>{percentage.amount}</Link>
          : <>{percentage.amount}</>
          }
          </MDTypography>
          &nbsp;{percentage.label}
        </MDTypography>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
};

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node.isRequired,
};

export default ComplexStatisticsCard;
